import { useQuery } from '@tanstack/react-query';
import { fetchAuditVersionHistory } from '@/api/audits';

const PAGE_SIZE = 10;

interface UseAuditVersionHistoryParams {
  id: string;
  page: number;
  sort?: string;
  filter?: Record<string, string[]>;
}

export function useAuditVersionHistory({
  id,
  page,
  sort,
  filter,
}: UseAuditVersionHistoryParams) {
  return useQuery({
    queryKey: ['audits', 'version-history', id, page, sort, filter],
    queryFn: () => {
      // The audits-service `/versions` route accepts ONLY page + count
      // (querystring is additionalProperties:false) — sending sort/filter
      // 400s. Matches v1, which fetches versions with page/count only.
      const qs = new URLSearchParams({
        page: String(page - 1),
        count: String(PAGE_SIZE),
      });
      return fetchAuditVersionHistory(id, qs.toString());
    },
    staleTime: 60_000,
  });
}

export const VERSION_HISTORY_PAGE_SIZE = PAGE_SIZE;
